import { render, staticRenderFns } from "./TypeTags.vue?vue&type=template&id=21293585&scoped=true&"
import script from "./TypeTags.vue?vue&type=script&lang=js&"
export * from "./TypeTags.vue?vue&type=script&lang=js&"
import style0 from "./TypeTags.vue?vue&type=style&index=0&id=21293585&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21293585",
  null
  
)

export default component.exports